<template>
    <div class="filingMaiBox">
        <div class="textOutPutBox">
            <h5>原因</h5>
            <van-field
                class="textOutPut"
                type="textarea"
                maxlength="200"
                placeholder="请填写原因"
                v-model="withdrawCaseMsg"
            >
            </van-field>
            <div class="textnum">{{withdrawCaseMsg.length}}/200</div>
        </div>
        <div class="btnBox">
            <div class="submitBtn" @click="handleClickSubmitMsg">提交</div>
            <div class="backBtn" @click="goBack()">返回</div>
        </div>
    </div>
</template>

<script>
    import api from '../../../../service/modules/complaintApis'
    import util from '@/utils/common'
    export default {
        data () {
            return {
                withdrawCaseMsg: '',
                itemList: util.getJsonLocal('item'),
                isback:this.$store.state.complaint.isBackDetail||util.getJsonLocal('isBack'),
            }
        },
        created () {
            // this.typeConversion()
        },
        methods: {

            goBack () { // 返回
                this.$router.go(-1);
            },
            handleClickSubmitMsg () { // 提交
                if (this.withdrawCaseMsg.trim().length === 0) {
                    this.$Toast('请填写撤案原因');
                } else {
                    let params = {
                        mainComplainNumber: this.itemList.mainComplainNumber,
                        complainNumber: this.itemList.complainNumber,
                        subId: this.itemList.subId,
                        content: this.withdrawCaseMsg
                    }
                    api.worker.revokeCase(params).then(res => {
                        console.log(res);
                        if (res.ret === 0) {
                            this.$Toast('操作成功');
                            this.$router.back();
                        }
                    })
                }
            }
        }
    }
</script>

<style lang="less" scoped>
    .filingMaiBox{
        width: 100%;
        padding: 0 15px;
        background-color: #fff;

        .textOutPutBox{
            width: 100%;
            height: 180px;
            margin-bottom: 10px;
            padding: 20px 0;
            position: relative;

            >h5{
                margin-bottom: 13px;
                font-size: 15px;
                font-weight: normal;
                line-height: 15px;
                color: #909090;
            }

            .textOutPut{
                height: 110px;
                padding: 15px 13px 10px;
                background-color: #F3F3F3;
                border-radius: 5px;
            }
            .textnum{
                position: absolute;
                bottom: 30px;
                right: 10px;
                color: #909090;
            }
        }

        .btnBox{
            width: 335px;
            margin: 0 auto;

            >div{
                width: 100%;
                height: 46px;
                font-size: 15px;
                text-align: center;
                line-height: 46px;
                border-radius: 5px;
            }

            .submitBtn{
                margin-bottom: 10px;
                color: #fff;
                background-color: #36B374;
            }

            .backBtn{
                color: #bdb8b8;
                background-color:#efeded;
                border: 1px solid #999;
            }
        }

    }
</style>
